import { createSelector } from "@reduxjs/toolkit";
import { InvestPoolType } from "../../types";
import { RootState } from "../store";
import { getAgriPoolsAction, getInvestPoolsAction } from "./invest.effects";

export const selectInvestState = (state: RootState) => state.invest;

export const selectInvestPools = (type: InvestPoolType) =>
  createSelector(selectInvestState, (state) => state[type].investPools || []);

export const selectIsGetInvestPoolsPending = createSelector(
  selectInvestState,
  (state) => state[getInvestPoolsAction.pending.type]
);

export const selectInvestPoolsPagination = (type: InvestPoolType) =>
  createSelector(selectInvestState, (state) => state[type].pagination);

export const selectAgriPools = createSelector(
  selectInvestState,
  (state) => state.AgriPool.investPools || []
);

export const selectIsGetAgriPoolsPending = createSelector(
  selectInvestState,
  (state) => state[getAgriPoolsAction.pending.type]
);

export const selectAgriPoolsPagination = createSelector(
  selectInvestState,
  (state) => state.AgriPool.pagination
);
